import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingService } from './../../services/setting.service';
import { UserService } from './../../services/user.service';
import { CommonService } from './../../services/common.service';
import { EncrDecrService } from '../../services/encr-decr.service';

@Component({
  selector: 'app-s-settings',
  templateUrl: './s-settings.component.html',
  styleUrls: ['./s-settings.component.css']
})

export class SSettingsComponent implements OnInit {
  user_id: any = '';
  APIKEY: any = '';
  settingForm: FormGroup;
  isBtnDisabled: boolean = false;
  submitted: any = false;
  //deep's code
  bankForm: FormGroup;
  isBtnDisabledforfbsf: boolean = false;
  submitted1: any = false;
  //end

  constructor(
    private _setting: SettingService,
    private _router: Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private _User: UserService, 
    private formBuilder: FormBuilder, 
    private _Common: CommonService
  ) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.setFormValue();
    this.getClickSendInfo();
    this.getMailgunInfo();
    this.bankInfo();
  }

  onSubmit() {
    this.submitted = true;
    this.isBtnDisabled = true;

    // stop here if form is invalid
    if (this.settingForm.invalid) {
      this.isBtnDisabled = false;
      return;
    }

    if (this.settingForm.get('clicksend_api_key').value =='' && this.settingForm.get('mailgun_api_key').value =='') {
      this.isBtnDisabled = false;
      alert("Please enter one access token key") ;
      return;
    }

    const formData = new FormData();
    formData.append('APIKEY', this.APIKEY);
    //formData.append('clicksend_api_key', this.EncrDecr.set(localStorage.getItem('key'), this.settingForm.get('clicksend_api_key').value));
    formData.append('clicksend_api_key', this.settingForm.get('clicksend_api_key').value);
    formData.append('clicksend_id', this.settingForm.get('clicksend_id').value);

    //formData.append('mailgun_api_key', this.EncrDecr.set(localStorage.getItem('key'), this.settingForm.get('mailgun_api_key').value));
    formData.append('mailgun_api_key', this.settingForm.get('mailgun_api_key').value);
    formData.append('mailgun_id', this.settingForm.get('mailgun_id').value);

    this._User.updateSSetting(formData).subscribe(
      res => {
        if (res.status == true) {  
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/super-admin/settings');
          });
        }
        else {
          this.toastr.error(res.message, 'Error');
        }
      }
    );
  }

  getClickSendInfo() {
    const data = {
      APIKEY: this.APIKEY,
      service_type: 'clicksend',
      feature_type: 'sms',
    }

    this._User.getSSettingInfo(data).subscribe(
      res => {
        //this.settingForm.get('clicksend_api_key').setValue(this.EncrDecr.get(localStorage.getItem('key'), res.data[0]['api_key']));
        this.settingForm.get('clicksend_api_key').setValue('');
        this.settingForm.get('clicksend_id').setValue(res.data[0]['id']);

      });
  }

  getMailgunInfo() {
    const data = {
      APIKEY: this.APIKEY,
      service_type: 'mailgun',
      feature_type: 'email',
    }

    this._User.getSSettingInfo(data).subscribe(
      res => {
        //this.settingForm.get('mailgun_api_key').setValue(this.EncrDecr.get(localStorage.getItem('key'), res.data[0]['api_key']));
        this.settingForm.get('mailgun_api_key').setValue('');
        this.settingForm.get('mailgun_id').setValue(res.data[0]['id']);

      });
  }

  setFormValue() {
    this.settingForm = this.formBuilder.group({
      //clicksend_api_key: ['', [Validators.required]],
      clicksend_api_key: [''],
      clicksend_id: [''],
      mailgun_api_key: [''],
      mailgun_id: [''],
    });
    this.bankForm = this.formBuilder.group({
      fbsf_id: [''],
      fbsf_token: [''],
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.settingForm.controls; }
  get form1() { return this.bankForm.controls; }

  onSubmitBank() {
    this.submitted1 = true;
    this.isBtnDisabledforfbsf = true;
    // stop here if form is invalid
    if (this.bankForm.invalid) {
      this.isBtnDisabledforfbsf = false;
      return;
    }
    if (this.bankForm.get('fbsf_id').value == undefined || this.bankForm.get('fbsf_token').value == undefined||this.bankForm.get('fbsf_id').value == null || this.bankForm.get('fbsf_token').value == null||this.bankForm.get('fbsf_id').value == '' || this.bankForm.get('fbsf_token').value == '') {
      this.isBtnDisabledforfbsf = false;
      alert("Please enter Bank Username and Passphrase");
      return;
    }
    const formData = new FormData();
    formData.append('fbsf_id', this.bankForm.get('fbsf_id').value);
    formData.append('fbsf_token', this.bankForm.get('fbsf_token').value);
    formData.append('APIKEY', this.APIKEY);
    this._User.updateBank(formData).subscribe(
      res => {
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/super-admin/settings');
          });
        }
        else {
          this.toastr.error(res.message, 'Error');
        }
      }
    );
  }

  bankInfo() {
    const data = {
      APIKEY: this.APIKEY,
      service_type: 'fbsf',
      feature_type: 'fbsf',
    }
    console.log("here",data);
    this._User.getSSettingInfo(data).subscribe(
      res => {
        this.bankForm.get('fbsf_id').setValue('');
        this.bankForm.get('fbsf_token').setValue('');
        console.log(this.bankForm.value, res);
      });

  }

}
